/**
 * Mr. Clippy — the buyer. A busy head of RevOps with a lot of inbound and not much patience:
 * curious, a little skeptical, quick to warm up when something actually works, never sarcastic.
 * His face is the meeting room's CharacterPresenter (the paperclip), mirrored into the landing with
 * the eye vocabulary; his persona defaults (narrow lids, a lean back, impatient breathing) are the
 * ones the first step sets, so he reads in character even before the data touches him.
 */
import { CharacterPresenter, type PresenterProps } from './CharacterPresenter';

export const CLIPPY_DEFAULT_PERSONA = { skeptic: 0.35, lean: -6, breath: 2.4 } as const;

export function MrClippy(props: PresenterProps) {
  return <CharacterPresenter {...props} persona={props.persona ?? CLIPPY_DEFAULT_PERSONA} />;
}
